export const UserRole={
    Admin:"admin",
    Viewer:"viewer",
    Editor:"editor"
}